import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { Table } from 'components';

import {
  formatUnitString,
  formatDateString,
  formatPhone,
} from 'utils/formatString';
import { getVAT } from 'utils/taxes';

import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

class DetailsTable extends PureComponent {
  prevCtn = null;

  getPortedColumns = () => [
    {
      name: 'detalization.expenses.detailsTable.dateTime',
      dataField: 'dateTime',
      transformer: (row) => formatDateString(row.dateTime, 'DD.MM.YYYY HH:mm:ss'),
      width: '20%',
    },
    {
      name: 'detalization.expenses.detailsTable.operation',
      dataField: 'operation',
      transformer: ({ operation, number }) => (
        number ? operation.replace(/\s*-$/, '') : operation
      ),
      width: '50%',
    },
    {
      name: 'detalization.expenses.detailsTable.balanceDiff',
      dataField: 'balances',
      transformer: (row) => row.balances.map(({ valueChange, unitCode }, index) => (
        <Fragment key={index}>
          {valueChange ? formatUnitString(valueChange, unitCode || 'CURRENCY') : '-'}
          {row.balances.length > 1 && (
            <>
              <br />
              <br />
            </>
          )}
        </Fragment>
      )),
      hidden: false,
      hideOnMobile: false,
    },
  ];

  render() {
    const {
      details,
      postpaid,
      showUserNumber,
      currency,
      isPorted,
    } = this.props;

    if (!details) {
      return null;
    }

    this.prevCtn = null;

    return (
      <Table
        data={details.filter((r) => r.dateTime)}
        className={cx('detailsTable')}
        config={{
          columns: isPorted ? this.getPortedColumns() : [
            {
              name: 'detalization.expenses.detailsTable.userNumber',
              dataField: 'ctn',
              hidden: !showUserNumber,
              transformer: ({ ctn }) => {
                if (ctn === this.prevCtn) return '';
                this.prevCtn = ctn;
                return ctn;
              },
              width: '120px',
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.dateTime',
              dataField: 'dateTime',
              transformer: (row) => formatDateString(row.dateTime, 'DD.MM.YYYY HH:mm:ss'),
              width: '90px',
            },
            {
              name: 'detalization.expenses.detailsTable.operation',
              dataField: 'operation',
              transformer: ({ operation, number }) => (
                number ? operation.replace(/\s*-$/, '') : operation
              ),
              width: '200px',
            },
            {
              name: 'detalization.expenses.detailsTable.number',
              dataField: 'number',
              transformer: ({ number }) => (
                number && number.substring(0, 2) === '79' && number.length === 11
                  ? formatPhone(number.substring(1, 11))
                  : number
              ),
              width: '150px',
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.trafficVolume',
              dataField: 'trafficVolume',
              transformer: ({ trafficVolume, trafficUnit }) => {
                if (!trafficVolume) {
                  return '—';
                }

                const volume = Math.round(parseFloat(trafficVolume) * 100) / 100;

                if (!trafficUnit) {
                  return volume;
                }

                return formatUnitString(volume, trafficUnit);
              },
              width: '170px',
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.balance',
              dataField: 'balances',
              transformer: (row) => row.balances.map(({ balanceText }, index) => (
                <Fragment key={index}>
                  {balanceText}
                  <br />
                </Fragment>
              )),
              width: '120px',
              hidden: postpaid,
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.balanceDiff',
              dataField: 'balances',
              transformer: (row) => row.balances.map(({ valueChange, unitCode }, index) => (
                <Fragment key={index}>
                  {valueChange ? formatUnitString(valueChange, unitCode) : '-'}
                  {row.balances.length > 1 && (
                    <>
                      <br />
                      <br />
                    </>
                  )}
                </Fragment>
              )),
              hidden: postpaid,
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.finalBalance',
              dataField: 'balances',
              transformer: (row) => row.balances.map(({ value, unitCode }, index) => (
                <Fragment key={index}>
                  {value ? formatUnitString(value, unitCode) : '-'}
                  <br />
                  <br />
                </Fragment>
              )),
              hidden: postpaid,
              hideOnMobile: true,
            },
            {
              name: 'detalization.expenses.detailsTable.cost',
              dataField: 'balances',
              transformer: (row) => (
                row.value
                  ? formatUnitString(row.value * (getVAT() + 1), currency)
                  : formatUnitString(0, currency)
              ),
              hidden: !postpaid,
            },
          ],
          uniqueIdField: 'dateTime',
          pageSize: 100,
        }}
      />
    );
  }
}

DetailsTable.propTypes = {
  details: PropTypes.array,
  postpaid: PropTypes.bool,
  showUserNumber: PropTypes.bool,
  currency: PropTypes.string,
  isPorted: PropTypes.bool,
};

export default DetailsTable;
